module.exports = __webpack_public_path__ + "img/c08_buildingtechhorsemanship_Normal_ua.7b0ad56a.webp";